import { armorAPI } from '~/services/api';
import { JSONTrackingConfig } from '~/types/TrackingSettings';

function fetchTrackingConfig() {
  return armorAPI.request({
    url: 'setting/tracking',
    method: 'GET',
  });
}

function updateTrackingConfig(payload: JSONTrackingConfig) {
  return armorAPI.request<JSONTrackingConfig>({
    url: '/setting/tracking',
    method: 'POST',
    headers: {},
    data: payload,
  });
}

export { fetchTrackingConfig, updateTrackingConfig };
